const carouselItems = [
  {
    title: '娱乐圈年度最大爆料事件全复盘',
    desc: '从蛛丝马迹到轰动全网，一篇带你回顾本年度娱乐圈最具爆炸性的连环爆料事件，独家梳理时间线与各方回应。',
    tag: '深度专题',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20editorial%20feature%20image%20with%20warm%20crimson%20and%20deep%20red%20gradients%2C%20abstract%20spotlight%20effect%2C%20cinematic%20composition%2C%20hollywood%20vibe%20but%20abstract%2C%20professional%20magazine%20cover%20style%2C%20no%20text&width=1200&height=600&seq=carousel-01-bl&orientation=landscape',
  },
  {
    title: '科技巨头们的秘密战争：你不知道的行业暗流',
    desc: '表面平静的科技行业背后，各大巨头正在进行一场不见硝烟的竞争。51爆料独家梳理科技圈最隐秘的商业博弈。',
    tag: '独家揭秘',
    image: 'https://readdy.ai/api/search-image?query=A%20mysterious%20corporate%20boardroom%20atmosphere%20with%20abstract%20digital%20screens%2C%20warm%20amber%20and%20dark%20red%20tones%2C%20geometric%20patterns%2C%20intense%20dramatic%20lighting%2C%20modern%20tech%20thriller%20vibe%2C%20no%20text&width=1200&height=600&seq=carousel-02-bl&orientation=landscape',
  },
  {
    title: '2026 上半年最受关注的十大社会话题',
    desc: '从民生热点到公共事件，51爆料为你盘点 2026 年上半年引发全网讨论的十大社会话题，回顾那些刷屏的时刻。',
    tag: '半年盘点',
    image: 'https://readdy.ai/api/search-image?query=An%20abstract%20urban%20landscape%20with%20warm%20sunset%20crimson%20and%20amber%20tones%2C%20city%20skyline%20silhouette%2C%20dramatic%20atmospheric%20clouds%2C%20editorial%20photography%20feel%2C%20geometric%20composition%2C%20no%20text&width=1200&height=600&seq=carousel-03-bl&orientation=landscape',
  },
  {
    title: '体育产业大变局：资本入局后的新格局',
    desc: '体育产业的资本化浪潮正在重塑整个行业。51爆料深入分析资本入局后体育圈发生的深远变化与未来趋势。',
    tag: '行业分析',
    image: 'https://readdy.ai/api/search-image?query=A%20dynamic%20abstract%20sports%20stadium%20scene%20with%20dramatic%20warm%20lighting%2C%20crimson%20and%20amber%20accents%2C%20motion%20energy%2C%20geometric%20patterns%2C%20professional%20editorial%20style%2C%20no%20text%20or%20recognizable%20people&width=1200&height=600&seq=carousel-04-bl&orientation=landscape',
  },
  {
    title: '互联网社区文化变迁：从论坛到短视频时代',
    desc: '中文互联网社区经历了怎样的变迁？51爆料带你回顾二十年网络文化演变，看社区形态如何影响信息传播方式。',
    tag: '文化观察',
    image: 'https://readdy.ai/api/search-image?query=An%20abstract%20digital%20evolution%20timeline%20visualization%2C%20warm%20amber%20and%20crimson%20gradients%2C%20geometric%20network%20patterns%20showing%20growth%2C%20modern%20infographic%20style%2C%20atmospheric%20lighting%2C%20no%20text&width=1200&height=600&seq=carousel-05-bl&orientation=landscape',
  },
  {
    title: '财经市场震荡背后：散户与机构的博弈实录',
    desc: '近期市场剧烈波动，散户力量崛起引发行业震动。51爆料详细记录这场史诗级博弈的关键节点与深层逻辑。',
    tag: '深度追踪',
    image: 'https://readdy.ai/api/search-image?query=An%20abstract%20financial%20market%20battle%20visualization%2C%20red%20and%20amber%20opposing%20forces%2C%20geometric%20data%20flows%20colliding%2C%20dramatic%20lighting%2C%20modern%20editorial%20style%2C%20intense%20atmosphere%2C%20no%20text&width=1200&height=600&seq=carousel-06-bl&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950">
            焦点专题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            深度策划专题内容，全方位解读热门事件
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/60 transition-all hover:border-primary-200 cursor-pointer"
            >
              <div className="relative w-full aspect-[2/1] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/50 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-semibold whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base font-semibold text-foreground-900 leading-snug mb-2 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3">
                  {item.desc}
                </p>
                <div className="mt-3 flex items-center gap-1 text-sm text-primary-600 font-medium cursor-pointer">
                  <span className="whitespace-nowrap">阅读全文</span>
                  <i className="ri-arrow-right-line text-sm"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}